import React from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Box,
	Typography,
	Divider,
	Table,
	TableHead,
	TableBody,
	TableRow,
	TableCell
} from "@mui/material";

import { calculateCommissionBreakdown } from "./commission";
import { formatCurrency } from "../../../utils/formatCurrency";
import { AffiliateTransfer } from "../../../store/services/affiliate/dto/affiliate.dto";

const formatTierRange = (from: number, to: number) =>
	to === Infinity ? `Above ${from.toLocaleString()}` : `${from.toLocaleString()} - ${to.toLocaleString()}`;

const TransferBreakdownModal = ({
	open,
	onClose,
	transfer
}: {
	open: boolean;
	onClose: () => void;
	transfer: AffiliateTransfer | null;
}) => {
	if (!transfer) return null;

	const rows = calculateCommissionBreakdown(transfer.totalSales);

	return (
		<Dialog open={open} onClose={onClose} maxWidth={"sm"} fullWidth>
			<DialogTitle>Commission Breakdown</DialogTitle>
			<DialogContent>
				<Box display={"flex"} justifyContent={"space-between"} flexWrap={"wrap"} gap={2} mb={2}>
					<Box>
						<Typography variant={"caption"} color={"textSecondary"}>
							Reference
						</Typography>
						<Typography fontWeight={600}>{transfer.reference}</Typography>
					</Box>
					<Box>
						<Typography variant={"caption"} color={"textSecondary"}>
							Total Sales
						</Typography>
						<Typography fontWeight={600}>{formatCurrency(transfer.totalSales, "EGP")}</Typography>
					</Box>
				</Box>

				<Table size={"small"}>
					<TableHead>
						<TableRow>
							<TableCell>Tier</TableCell>
							<TableCell>Rate</TableCell>
							<TableCell align={"right"}>Sales in Tier</TableCell>
							<TableCell align={"right"}>Commission</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{rows.map(row => (
							<TableRow key={row.from}>
								<TableCell>{formatTierRange(row.from, row.to)}</TableCell>
								<TableCell>{(row.rate * 100).toFixed(0)}%</TableCell>
								<TableCell align={"right"}>{formatCurrency(row.salesInTier, "EGP")}</TableCell>
								<TableCell align={"right"}>{formatCurrency(row.commission, "EGP")}</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>

				<Divider sx={{ my: 2 }} />

				<Box display={"flex"} justifyContent={"space-between"}>
					<Typography fontWeight={700}>Total Commission Transferred</Typography>
					<Typography fontWeight={700}>{formatCurrency(transfer.totalCommission, "EGP")}</Typography>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Close</Button>
			</DialogActions>
		</Dialog>
	);
};

export default TransferBreakdownModal;
